// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q0eE","questions":"styles_questions__1h_ma","footer":"styles_footer__TnKnP"};